
export default function clipboard(text) {
    // Warning: ugly hack
    // There is not any way to copy text to clipboard directly
    // Also copy text from hidden input is not allowed

    const input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
}
